module.exports = __webpack_public_path__ + "static/media/amazing_restaurant_1.a3889774.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/images/amazing_restaurant_1.jpg
// module id = 301
// module chunks = 0